import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'common/components/elements/inputs/checkbox-label';
import Input from "common/components/elements/inputs/inputs";


const PaidPrereleaseInputs = ({
   access,
   inputName,
   onChange,
   isPriceError,
   maxPrice,
   onWrongPriceLength,
   priceValidation,
   onFocus,
   setError,
}) => {
   let inputNamePrefix = inputName ? `_${ inputName }` : '';
   const downloadPrefix = `for_${ access.type }`;
   const availableName = `pre_release_available_${ downloadPrefix }`;
   const priceName = `pre_release_price_${ downloadPrefix }`;
   let isError = isPriceError && priceValidation(access[priceName]);
   if(+access[priceName] === 0 && 'unlocked' === access.type) {
      isError = false
   }

   return (
      <div
         role='presentation'
         onClick={ e => e.stopPropagation() }
         className='flex flex-col mt-3 ml-9'>

         <div className='flex items-center'>
            <div>
               <CheckBox
                  label='Allow prerelease access'
                  name={ `${ availableName }${ inputNamePrefix }` }
                  checked={ access[availableName] }
                  onChange={ (name, value) => {
                     const price = access[priceName];
                     if(+price === 0 && 'unlocked' === access.type) {
                        setError('unlock', false);
                     } else {
                        if(priceValidation(price)) {
                           setError('unlock', true);
                        }
                     }
                     onChange(availableName, !access[availableName]);
                  } }
                  textColor='secondary'
                  disabled={ false }
                  padding='0'
                  className='w-full'
                  margin='2'
               />
            </div>

         </div>
         {
            !!access[availableName] && (
               <div className='w-full mt-3 cursor-auto'>
                  <Input
                     rightText='USD'
                     value={ access[priceName] }
                     name={ `${ priceName }${ inputNamePrefix }` }
                     onChange={ (name, value) => {
                        const price = !value ? value : +value;
                        if(price === 0 && 'unlocked' === access.type) {
                           setError('unlock', false);
                           onChange(priceName, price)
                        } else {
                           if(isError) {
                              setError('unlock', true);
                           }
                           // if(onWrongPriceLength(value)) return
                           onChange(priceName, price)
                        }
                     } }
                     autoComplete='off'
                     errorMessage={ isError ? `Price must be between 0.25 USD and ${ maxPrice } USD` : null }
                     onInputFocus={ onFocus }
                     isPriceInput
                     maxPrice={ maxPrice }
                     type={ 'number' }
                  />
               </div>

            )
         }
      </div>
   )
}

PaidPrereleaseInputs.propTypes = {
   onChange: PropTypes.func,
   inputName: PropTypes.any,
   access: PropTypes.object,
   maxPrice: PropTypes.number,
   isPriceError: PropTypes.bool,
   onWrongPriceLength: PropTypes.func,
   priceValidation: PropTypes.func,
   onFocus: PropTypes.func,
   setError: PropTypes.func,
}

export default PaidPrereleaseInputs
